<template>
  <div>
    <div aria-hidden="true" aria-labelledby="draftPosterModalLabel" data-backdrop="static" class="modal fade" id="draftPosterModal"
         role="dialog" tabindex="-1">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <form @submit.prevent="createPosters()" id="posters" method="POST" name="posters">
            <div class="modal-header">
              <h5 class="modal-title">Criação de ofertas em massa</h5>
              <button aria-label="Close" class="close" data-dismiss="modal" data-v-3bc8e93f="" type="button">
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div class="modal-body">
              <create-posters-in-bulk-through-drafts
                  v-model="form"
                  :errors="errors"
                  :sub-domain="null"
                  :draft-poster="firstPoster"
                  :posterPermissions="posterPermissions"
              />
            </div>

            <div class="modal-footer">
              <div class="col-12">
                <button
                    class="btn btn-outline-secondary float-left" data-dismiss="modal" type="button">
                  Fechar
                </button>

                <button
                    type="submit"
                    class="btn btn-outline-secondary waves-effect waves-light float-right">
                  Criar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="fixed-posters-action" v-show="totalPosters > 0">
      <div class="col-md-12 posters-actions row m-0">
        <div class="col-md-9 col-12 text-center">
          <span class=" py-2 font-16">Selecionados até o momento: {{ totalPosters }}</span>
        </div>

        <div class="col-md-3 col-12">
          <div class="row d-block">
            <button
                @click="$emit('loadDraftPosterData')"
                class="btn btn-secondary btn-block btn-lg text-white"
                data-target="#draftPosterModal"
                data-toggle="modal"
                id="printButton"
                type="button">
              Criar ofertas em massa
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "draft-posters-actions",
  props: {
    urlAction: String,
    posterPermissions: Object,
  },
  data() {
    return {
      errors: [],
      form: {
        campaign_name: null,
        format_name: null,
        template_name: null,
        theme_name: null,
        valid_from: null,
        valid_until: null,
        poster_ids: []
      },
    }
  },
  watch: {
    selectedPosters(posters) {
      this.form.poster_ids = posters.map((poster) => poster.id);
    }
  },
  computed: {
    csrf() {
      return $('meta[name="csrf-token"]').attr('content');
    },
    firstPoster() {
      if (this.selectedPosters.length)
        return this.selectedPosters[0];
    },
    selectedPosters: {
      get() {
        return this.$store.getters['printPosters/getSelectedPosters'];
      },
      set(posterId) {
        this.$store.commit('printPosters/SET_POSTERS_SELECTED', posterId);
      },
    },
    totalPosters() {
      return this.selectedPosters.length;
    },
  },
  methods: {
    createPosters() {
      this.errors = [];
      axios.post(this.urlAction, this.form).then(response => {
        const data = response.data;
        if (data.type && data.type === 'success') {
          this.$root.$emit('reset-data');
          window.location.reload()
        }
        this.$root.throwFlashMessage(data.type, data.message);
      }).catch(error => {
        let response = error.response;
        if (response) {
          this.errors = response.data.errors;
        }
      });
    },
  }
}
</script>

<style scoped>
.fixed-posters-action {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  position: fixed;
  bottom: 0;
  border-top: 1px solid coral;
  color: #354558;
  left: 0;
  background-color: #ffffff;
}

.posters-actions {
  display: flex;
  align-items: center;
  padding: 15px 2.5vw;
}

@media screen and (max-width: 768px) {
  .fixed-posters-action {
    padding-left: 0;
    width: 100%;
  }

  .posters-actions {
    padding: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/poster-automation/DraftPostersActions.vue